// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { Preferences } from '@capacitor/preferences'
import { createQueryParameters } from '@utils/object-helper'
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type GetUserGroupsResponse = (SuccessResponse & {
    groups: Group[]
}) | FailedResponse

interface GetUserGroupsParams {
    page?: number
    size?: number
    status?: typeof GetUserGroupsRequest.statuses[number]
}

export class GetUserGroupsRequest extends Request {
    public static readonly statuses = ['active', 'completed', 'canceled'] as const
    public readonly params: GetUserGroupsParams

    private constructor(userId: string, params: GetUserGroupsParams = { page: 1, size: 10, status: 'active' }, init?: RequestInit) {
        super(`${vcBaseUrl}/user/${userId}/groups${createQueryParameters(params)}`, init)
        this.params = params
    }

    static async init(userId: string, params?: GetUserGroupsParams, init?: RequestInit) {
        params = {
            page: Math.abs(params?.page || 1),
            size: Math.abs(params?.size || 10),
            status: this.statuses.find((status) => status === params?.status) || 'active'
        }
        return new GetUserGroupsRequest(userId, params, {
            ...init,
            method: 'GET',
            headers: await generateHeaders("Clerk-Token", init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<Group[]> {
        const response = await fetch(this)
        const data = createResponseObj<GetUserGroupsResponse>(await response.json())
        console.info("Get User Groups Response:", data)
    
        switch (data.status) {
            case 'successful': return data.groups
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}

export const getUserGroups = async (userId: string, params?: GetUserGroupsParams): Promise<Group[]> => {
    const request = await GetUserGroupsRequest.init(userId, params)
    const response = await fetch(request)
    const data = createResponseObj<GetUserGroupsResponse>(await response.json())
    console.info("Get User Groups Response:", data)

    switch (data.status) {
        case 'successful': return data.groups
        case 'failed': throw data
        default: throw new Error(`Unsupported Status: ${data}`)
    }
}